const data = [
    { 
        id: 1, 
        name: 'Confirmação do pedido enviado pela empresa por e-mail (documento integral em formato .pdf)', 
    },
    { 
        id: 2, 
        name: 'Comprovante de pagamento (pix, boleto ou cartão de crédito)',
    },
    { 
        id: 3, 
        name: 'Comprovante da reserva enviado pela empresa por e-mail (documento integral em formato .pdf)',
    },
    { 
        id: 4, 
        name: 'Comprovante de cancelamento da reserva enviado pelo hotel',
    },
    { 
        id: 5, 
        name: 'Comprovante de emissão da nota fiscal em favor do hóspede na data do checkout, demonstrando que houve a estadia pelo cliente no período contratado',
    },
    { 
        id: 6, 
        name: 'Comprovante de cancelamento da passagem aérea emitido pela companhia aérea',
    },
    { 
        id: 7, 
        name: 'Comprovante de aquisição de nova passagem para o trecho e data',
    },
    { 
        id: 8, 
        name: 'Extrato atualizado de acúmulo e resgate do programa de fidelidade (LatamPass, Tudo Azul, TAP Miles&Go e/ou Smiles) desde a data da cotação das milhas, com indicação do localizador das passagens aéreas emitidas',
    },
    { 
        id: 9, 
        name: 'Comprovante da emissão de passagem aérea através do programa de fidelidade (LatamPass, Tudo Azul, TAP Miles&Go e/ou Smiles) enviado por e-mail pela empresa, com indicação do localizador da passagem e dados do passageiro',
    },
    { 
        id: 10, 
        name: 'Comprovante de cancelamento',
    },
    { 
        id: 11, 
        name: 'Cópia integral do processo judicial',
    },
    { 
        id: 12, 
        name: 'Documento que indique o número do processo ajuizado',
    },
    { 
        id: 13, 
        name: 'Certidão de habilitação de crédito e/ou sentença e certidão de trânsito em julgado',
    },
    { 
        id: 14, 
        name: 'Comprovante de aprovação da cotação de milhas',
    },
    { 
        id: 15, 
        name: 'Documentos comprobatórios do valor já reconhecido na relação de credores (contratos, faturas, notas fiscais com aceite, títulos protestos, faturas, e-mails entre as partes, fotografias, telas do sistema de reservas, entre outros), em PDF',
    },
    { 
        id: 16, 
        name: 'Documentos comprobatórios do valor que pretende incluir (contratos, faturas, notas fiscais com aceite, títulos protestos, faturas, e-mails entre as partes, fotografias, telas do sistema de reservas, entre outros), em PDF',
    },
    { 
        id: 17, 
        name: 'Contrato(s)',
    },
    { 
        id: 18, 
        name: 'Nota(s) fiscal(is) com aceite',
    },
    { 
        id: 19, 
        name: 'Tela do sistema de reservas',
    },
    { 
        id: 20, 
        name: 'Cópia integral da CTPS',
    },
    { 
        id: 21, 
        name: 'Termo de rescisão do contrato de trabalho',
    },
    { 
        id: 22, 
        name: 'Extrato atualizado do FGTS',
    },
    { 
        id: 23, 
        name: 'Memória de cálculo discriminada e atualizada até a data do ajuizamento do pedido de recuperação judicial (29/08/2023)',
    },
    { 
        id: 24, 
        name: 'Memória de cálculo discriminada e atualizada até a data do ajuizamento do pedido de recuperação judicial (21/09/2023)',
    },
    { 
        id: 25, 
        name: 'Relatório de check-in',
    },
    { 
        id: 26, 
        name: 'Documento indicando a data da reserva',
    },
    { 
        id: 27, 
        name: 'Comprovação da prestação dos serviços',
    },
    { 
        id: 28, 
        name: 'Comprovação da recusa do pagamento ou do cancelamento (Lance Hotéis)',
    },
    { 
        id: 29, 
        name: 'Relação de títulos oferecidos em garantia',
    },
    { 
        id: 50, 
        name: 'Outro',
    },


];

export default [...data];